import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import UnbxdCards from "../UnbxdCards/UnbxdCards";
import stl from "./UnbxdPosts.module.css";
import loadable from "@loadable/component";
import useIsMobile from "@hooks/useIsMobile";
import { thumbUrl } from "@/utils/imagesHelpers";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import WithScrollToTop from "@/common/HOCs/WithScrollToTop/WithScrollToTop";
import { CDN_LINK } from "@globalConfig";
import UnbxdTitleArea from "@/components/SearchComponent/UnbxdComponents/UnbxdTitleArea/UnbxdTitleArea";
import MarketingBanner from "@/components/SearchComponent/NewComponents/MarketingBanner/MarketingBanner";
import UnbxdSEOChips from "@/components/SearchComponent/UnbxdComponents/UnbxdSEOChips/UnbxdSEOChips";
import { useEffect, useRef, useState } from "react";
import { useLocation, useMatch, useSearchParams } from "react-router-dom";
import { useAuthActions } from "@/_MiniApps/auth/AuthContext";
import { useTranslation } from "@i18n";
import SaveSearchBanner from "@/components/SearchComponent/UnbxdComponents/UnbxdSaveSearch/SaveSearchBanner";
import BlueSnackBar from "@/_MiniApps/CarCompare/Components/BlueSnackBar";
import StartCompareBar from "@/_MiniApps/CarCompare/Components/StartCompareBar";
import { Pagination } from "@syarahtech/ui";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import { SearchUspsProvider } from "@/components/SearchComponent/UnbxdComponents/SearchUsps/SearchUspsContext";
import Container from "@/components/sharedComponents/container/Container";
import SEOInternalLinks from "@/components/SearchComponent/SEOInternalLinks/SEOInternalLinks";
import UsedCarsUnder30KSection from "./UsedCarsUnder30KSection/UsedCarsUnder30KSection";
import ChineseUsedCarsSection from "@/components/SearchComponent/UnbxdComponents/UnbxdPosts/ChineseUsedCarsSection/ChineseUsedCarsSection";
import Markdown from "markdown-to-jsx";
import ExpandableText from "@/components/shared/ExpandableText/ExpandableText";
import { If } from "@componentsShared/Conditional/If";
import useBoolean from "@hooks/useBoolean";
import { twMerge } from "tailwind-merge";
import SEOAboutSection from "@/components/SearchComponent/SEOAboutSection/SEOAboutSection";
var fallback = {
  fallback: null
};
var EmptySearchResult = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "EmptySearchResult-EmptySearchResult";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "EmptySearchResult-EmptySearchResult" */"../EmptySearchResult/EmptySearchResult");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../EmptySearchResult/EmptySearchResult");
    }
    return eval('require.resolve')("../EmptySearchResult/EmptySearchResult");
  }
}, fallback);
var UnbxdRecommendationCards = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-SearchComponent-UnbxdComponents-UnbxdRecommendation-UnbxRecommendationCards";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-SearchComponent-UnbxdComponents-UnbxdRecommendation-UnbxRecommendationCards" */"@/components/SearchComponent/UnbxdComponents/UnbxdRecommendation/UnbxRecommendationCards");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/components/SearchComponent/UnbxdComponents/UnbxdRecommendation/UnbxRecommendationCards");
    }
    return eval('require.resolve')("@/components/SearchComponent/UnbxdComponents/UnbxdRecommendation/UnbxRecommendationCards");
  }
}, fallback);
var UnbxdPosts = function UnbxdPosts() {
  var _useFilterPage = useFilterPage(),
    loading = _useFilterPage.isLoading,
    page = _useFilterPage.page,
    isAutosPage = _useFilterPage.isAutosPage,
    isYearsPage = _useFilterPage.isYearsPage,
    isDealPage = _useFilterPage.isDealPage,
    isSearchSaved = _useFilterPage.isSearchSaved,
    total_pages = _useFilterPage.total_pages,
    setPage = _useFilterPage.setPage;
  var _useSearchResultsData = useSearchResultsData(),
    filters = _useSearchResultsData.filters,
    usps = _useSearchResultsData.usps,
    marketingBanner = _useSearchResultsData.marketingBanner,
    selectedOptions = _useSearchResultsData.selectedOptions,
    posts = _useSearchResultsData.posts,
    metaData = _useSearchResultsData.metaData,
    pageDescription1 = _useSearchResultsData.pageDescription1,
    pageDescription2 = _useSearchResultsData.pageDescription2;
  var _useTranslation = useTranslation(),
    tLong = _useTranslation.tLong,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var isFiltersPage = !(isAutosPage || isYearsPage);
  var stickyRef = useRef(null);
  var _useAuthActions = useAuthActions(),
    remote_saveSearchHistory = _useAuthActions.remote_saveSearchHistory; // Access the function
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var searchTermParam = searchParams.get("text");
  var banner = marketingBanner === null || marketingBanner === void 0 ? void 0 : marketingBanner[isMobile ? "mobile" : "desktop"];
  var url = typeof window !== "undefined" ? window.location.href : "/";
  var _useState = useState(null),
    prevSearchTerm = _useState[0],
    setPrevSearchTerm = _useState[1];
  var currentPage = page;
  var isYearsMakeRoute = useMatch("/years/:year/:make");
  var isYearsRoute = useMatch("/years");
  var isMakeModelYearRoute = useMatch("/autos/:make/:model/:year");
  var isUsedCarsRouteAr = useMatch("/autos/used-cars");
  var isUsedCarsRouteEn = useMatch("/en/autos/used-cars");
  var isMakeModelRouteAr = useMatch("/autos/:make/:model");
  var isMakeModelRouteEn = useMatch("/en/autos/:make/:model");
  var isMakeRouteAr = useMatch("/autos/:make");
  var isMakeRouteEn = useMatch("en/autos/:make");
  var isUsedCarsRoute = isUsedCarsRouteAr || isUsedCarsRouteEn;
  var isLessWrapper = !!isYearsMakeRoute || !!isMakeModelYearRoute || !!isYearsRoute;
  var expandableText = useBoolean(false);
  var location = useLocation();
  useEffect(function () {
    if (searchTermParam && searchTermParam !== prevSearchTerm &&
    // Check if search term changed
    !loading && posts.length > 0) {
      // Save search to history
      remote_saveSearchHistory({
        text: searchTermParam,
        label_ar: searchTermParam,
        label_en: searchTermParam,
        searched_at: Math.floor(Date.now() / 1000),
        filters: null,
        result_count: posts.length
      });

      // Update the previous search term state
      setPrevSearchTerm(searchTermParam);
    }
  }, [prevSearchTerm, loading, posts === null || posts === void 0 ? void 0 : posts.length]);
  useEffect(function () {
    if (__IS_SSR__) return;
    expandableText.setFalse();
  }, [location === null || location === void 0 ? void 0 : location.pathname]);
  return /*#__PURE__*/React.createElement("div", {
    className: stl.mainWrapper
  }, !isFiltersPage && /*#__PURE__*/React.createElement("div", {
    className: isLessWrapper ? stl.autosAndTagsWrapperLess : stl.autosAndTagsWrapper
  }, !isFiltersPage && /*#__PURE__*/React.createElement(UnbxdSEOChips, null)), /*#__PURE__*/React.createElement("div", {
    className: [stl.searchResultContainer, stl.mainPostsWrapper].join(" ")
  }, (isDealPage || !isMobile && (banner || loading)) && /*#__PURE__*/React.createElement(MarketingBanner, {
    src: thumbUrl(banner, "hero-v1", isMobile ? "0x154" : "0x960"),
    progressiveSmallImage: thumbUrl(banner, "hero-v1", isMobile ? "0x99" : "0x154"),
    width: isMobile ? 351 : 1200,
    height: isMobile ? 119 : 187,
    marketingBanner: marketingBanner,
    loading: loading && !banner
  }), /*#__PURE__*/React.createElement("div", {
    ref: stickyRef
  }, !isSearchSaved && /*#__PURE__*/React.createElement("div", {
    className: "xl:hidden my-4"
  }, /*#__PURE__*/React.createElement(SaveSearchBanner, null)), /*#__PURE__*/React.createElement(UnbxdTitleArea, {
    loading: loading
  }), /*#__PURE__*/React.createElement(If, {
    condition: pageDescription1 && pageDescription2 && !loading && isAutosPage && (posts === null || posts === void 0 ? void 0 : posts.length) > 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1275px] 2xl:max-w-[1320px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded pe-6 mt-4 mb-6 py-1 md:py-3 md:ps-6 md:pe-14 md:mb-8 md:mt-0 relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-20 h-20 transform-origin left-[-20px] en:right-[-20px] en:left-[unset] top-[18.85px] absolute opacity-20 rounded-full border-[15px] border-indigo-100 border-solid"
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-3.5 h-3.5 en:left-[unset] en:right-[59px]  left-[59px] top-[26.85px] absolute opacity-20 rounded-full border-2 border-indigo-100 border-solid"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("line-clamp-1", expandableText.value && "line-clamp-none")
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-text text-xs font-medium md:text-base leading-6"
  }, pageDescription1), /*#__PURE__*/React.createElement("span", {
    className: twMerge("text-gray-text text-xs font-medium md:text-base leading-6 ms-0.5")
  }, pageDescription2), /*#__PURE__*/React.createElement(If, {
    condition: expandableText.value
  }, /*#__PURE__*/React.createElement("span", {
    onClick: expandableText.setFalse,
    className: "m-0 p-0 text-xs md:text-base text-primary ms-1 cursor-pointer hover:text-primary-120 transition-colors duration-200"
  }, tShort("less")))), /*#__PURE__*/React.createElement(If, {
    condition: !expandableText.value
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center z-[2] md:-ms-1 mt-1 absolute en:left-[unset] en:right-[10px] md:en:right-[38px] left-[10px] bg-white ps-1 gap-px md:left-[38px] md:m-0"
  }, /*#__PURE__*/React.createElement("span", null, "..."), /*#__PURE__*/React.createElement("span", {
    onClick: expandableText.setTrue,
    className: "m-0 p-0 text-xs md:text-base text-primary cursor-pointer hover:text-primary-120 transition-colors duration-200"
  }, tShort("more")))))))))), loading && isDesktop && /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "mt-1",
    divHeight: isMobile ? 40 : 40,
    divWidth: 400
  })), !loading && posts.length === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(EmptySearchResult, {
    filters: filters
  }), /*#__PURE__*/React.createElement(UnbxdRecommendationCards, null))), /*#__PURE__*/React.createElement(SearchUspsProvider, null, /*#__PURE__*/React.createElement(UnbxdCards, {
    loading: loading,
    posts: posts,
    usps: usps,
    page: page,
    metaData: metaData
  })), /*#__PURE__*/React.createElement("div", {
    className: "py-8"
  }, isAutosPage && total_pages > 1 && !loading && /*#__PURE__*/React.createElement(Pagination, {
    baseUrl: url,
    currentPage: currentPage,
    totalPages: total_pages,
    as: "link",
    onPageChange: function onPageChange(page) {
      setPage(page);
    }
  })), isUsedCarsRoute && /*#__PURE__*/React.createElement(UsedCarsUnder30KSection, null), isUsedCarsRoute && /*#__PURE__*/React.createElement(ChineseUsedCarsSection, null), isUsedCarsRoute && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "rounded-md bg-[#F2F4F6] md:bg-white max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1275px] 2xl:max-w-[1320px] mx-auto px-4 py-5 md:px-8"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[#154F9C] text-2xl font-bold py-4"
  }, tShort("used_cars_guide")), /*#__PURE__*/React.createElement(ExpandableText, {
    showMoreText: tShort("more"),
    showLessText: tShort("less"),
    buttonClassName: "bg-[#F6F6F6] shadow-[0_0_1.8px_0_rgba(0,0,0,0.15)] md:bg-gray-100 w-[80px] text-center text-[#3C56D4] mt-3 px-3 py-2 rounded font-medium text-sm cursor-pointer hover:bg-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: "text-[#404955] text-[16px] leading-[30px]"
  }, tLong("searchUsp/usedCarsGuid", {
    ns: "web_search"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "h-5"
  })), !loading && isAutosPage && /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SEOInternalLinks, {
    selectedOptions: selectedOptions,
    metaData: metaData,
    filters: filters
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(isMakeModelRouteAr || isMakeModelRouteEn || isMakeRouteAr || isMakeRouteEn)
  }, /*#__PURE__*/React.createElement(SEOAboutSection, null)), !isAutosPage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WithScrollToTop, {
    renderFunction: function renderFunction(_ref) {
      var onClick = _ref.onClick,
        isMouseOver = _ref.isMouseOver;
      return /*#__PURE__*/React.createElement("div", {
        onClick: onClick,
        className: isMouseOver ? "isMouseOver" : ""
      }, /*#__PURE__*/React.createElement("img", {
        width: "40px",
        src: CDN_LINK + "/assets/images/Backtotop.svg",
        alt: "Back To Top"
      }));
    }
  }))), /*#__PURE__*/React.createElement(BlueSnackBar, {
    postsLength: posts.length,
    loading: loading
  }), /*#__PURE__*/React.createElement(StartCompareBar, null));
};
export default UnbxdPosts;